import { media, styled } from '@styles';
import { Container } from '@components/templates/Container';
import { paddingLeft, pageTitle } from '@styles/utils';

export const Wrapper = styled.div`
  background-color: ${(props) => props.theme.colors.white};
`;

export const ProductDetails = styled.div`
  // height: calc(100vh - 200px);
  overflow-y: hidden;
  display: flex;
  background-color: #ece5e7;
  // min-height: 816px;
  ${media.smMediumScreen`
    flex-wrap: wrap;
    position: relative;
    height: 100%;
  `}
`;

export const ProductViewWr = styled.div`
  position: relative;
  width: 100%;
  height: 90vh;
  flex-grow: 1;
  overflow: hidden;
  ${media.smMediumScreen`
    height: 52vh;
  `}
  ${media.xSmallScreen`
    height: 60vh;
  `}
  ${media.smallestScreen`
    height: 60vh;
  `}
`;

export const ProductControlsWr = styled.div`
  position: relative;
  width: 750px;
  display: flex;
  align-items: flex-start;
  overflow: visible;
  background: #ece5e7;
  ${media.mediumScreen`
    width: 40vw;
  `}
  ${media.smMediumScreen`
    width: 100%;
    height: 100%;
    position: static;
    overflow: visible;
  `}
`;

export const OtherProducts = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  padding: 200px 0;
  ${media.largeScreen`
    padding: 120px 0;
  `}
  ${media.smallScreen`
    padding: 80px 0;
  `}
  //TODO and fix overflowing
  overflow: hidden;
`;

export const OtherProductsWrapper = styled(Container)`
  ${paddingLeft}
`;

export const OtherProductsTitle = styled.div`
  margin-bottom: 30px;
  ${media.smallScreen`
    margin-bottom: 20px;
  `}
  ${pageTitle}
`;

export const OtherProductsList = styled.div`
  & > div {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    ${media.smallScreen`
      grid-template-columns: repeat(2, minmax(0, 1fr));
    `}
  }
`;
